import React from 'react';
import './ThemeSelector.css';

// Extended themes with more options and variants
const themes = [
  // Original & common
  { id: 'dark', name: 'Dark', colors: { primary: '#5553e7', bg: '#15171f', boxBg: '#20222c' } },
  { id: 'white', name: 'White', colors: { primary: '#6361e7', bg: '#ffffff', boxBg: '#f5f5f5' } },
  { id: 'blue', name: 'Blue', colors: { primary: '#2196F3', bg: '#0d47a1', boxBg: '#1565c0' } },
  { id: 'crimson', name: 'Crimson Red', colors: { primary: '#dc143c', bg: '#1a0000', boxBg: '#2d0000' } },
  { id: 'purple', name: 'Purple', colors: { primary: '#9c27b0', bg: '#1a0033', boxBg: '#2d0057' } },
  { id: 'green', name: 'Green', colors: { primary: '#4caf50', bg: '#0a1f0a', boxBg: '#1a3a1a' } },
  { id: 'orange', name: 'Orange', colors: { primary: '#ff9800', bg: '#331a00', boxBg: '#4d2600' } },
  { id: 'pink', name: 'Pink', colors: { primary: '#e91e63', bg: '#1a000a', boxBg: '#2d0014' } },
  { id: 'cyan', name: 'Cyan', colors: { primary: '#00bcd4', bg: '#003d47', boxBg: '#005662' } },
  { id: 'indigo', name: 'Indigo', colors: { primary: '#3f51b5', bg: '#0d1129', boxBg: '#1a2347' } },

  // New/Extra themes
  { id: 'gold', name: 'Gold', colors: { primary: '#ffd600', bg: '#322900', boxBg: '#4c4000' } },
  { id: 'aqua', name: 'Aqua', colors: { primary: '#1de9b6', bg: '#00332b', boxBg: '#20443e' } },
  { id: 'night', name: 'Night Sky', colors: { primary: '#90caf9', bg: '#121530', boxBg: '#1c2240' } },
  { id: 'sunset', name: 'Sunset', colors: { primary: '#ff7043', bg: '#331525', boxBg: '#502e35' } },
  { id: 'rose', name: 'Rose', colors: { primary: '#ff5f7e', bg: '#30101a', boxBg: '#4c2030' } },
  { id: 'mint', name: 'Mint', colors: { primary: '#43e695', bg: '#112921', boxBg: '#21383a' } },
  { id: 'coffee', name: 'Coffee', colors: { primary: '#795548', bg: '#2c1a10', boxBg: '#3e2620' } },
  { id: 'slate', name: 'Slate', colors: { primary: '#607d8b', bg: '#14191f', boxBg: '#232c36' } },
  { id: 'violet', name: 'Violet Dream', colors: { primary: '#a259f7', bg: '#2a183a', boxBg: '#371d55' } },
  { id: 'deepred', name: 'Deep Red', colors: { primary: '#c62828', bg: '#2b0f0f', boxBg: '#421717' } },
  { id: 'lime', name: 'Lime Green', colors: { primary: '#cddc39', bg: '#29321a', boxBg: '#374923' } },
  { id: 'silver', name: 'Silver', colors: { primary: '#b0bec5', bg: '#36393f', boxBg: '#444850' } },
  { id: 'classic', name: 'Classic', colors: { primary: '#7289da', bg: '#36393f', boxBg: '#202225' } },
  { id: 'peach', name: 'Peach', colors: { primary: '#ffb347', bg: '#403125', boxBg: '#5c442c' } },
  { id: 'forest', name: 'Forest', colors: { primary: '#388e3c', bg: '#173217', boxBg: '#225325' } },
  { id: 'ocean', name: 'Ocean', colors: { primary: '#039be5', bg: '#13334c', boxBg: '#22557a' } },
  { id: 'space', name: 'Space', colors: { primary: '#ffffff', bg: '#11141b', boxBg: '#1c2028' } },
  { id: 'lavender', name: 'Lavender', colors: { primary: '#b284be', bg: '#251631', boxBg: '#352142' } }
];

function ThemeSelector({ currentTheme, onThemeChange }) {
  return (
    <div className="theme-selector">
      <label htmlFor="theme-selector__select">Theme:</label>
      <select
        id="theme-selector__select"
        value={currentTheme}
        onChange={(e) => onThemeChange(e.target.value)}
      >
        {themes.map(theme => (
          <option key={theme.id} value={theme.id}>
            {theme.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export { themes };
export default ThemeSelector;
